import { MOSIDA_API_BASE_URL } from '../config/apiUrls';

const baseUrl = MOSIDA_API_BASE_URL;
const apiKey = process.env.REACT_APP_CREATIVE_API_KEY || '';

export interface PinCodeResponse {
  success: boolean;
  pinCode?: string;
  error?: string;
}

function getHeaders(): HeadersInit {
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
  };

  if (apiKey) {
    headers['X-API-Key'] = apiKey;
  }

  return headers;
}

/**
 * Get the active PIN code from the API
 * This endpoint accepts either API key or JWT token
 */
export async function getActivePinCode(): Promise<PinCodeResponse> {
  try {
    const response = await fetch(`${baseUrl}/admin/pin-code/public`, {
      method: 'GET',
      headers: getHeaders(),
    });

    if (!response.ok) {
      const errorText = await response.text();
      return {
        success: false,
        error: `Failed to fetch PIN code: ${response.status} ${errorText}`,
      };
    }

    const data = await response.json();
    
    if (data && data.pinCode) {
      return {
        success: true,
        pinCode: data.pinCode,
      };
    }

    return {
      success: false,
      error: 'Invalid response format from API',
    };
  } catch (error: any) {
    return {
      success: false,
      error: error?.message || 'Network error while fetching PIN code',
    };
  }
}

